<!--
 * @Descripttion:
 * @Author: Niu Chenxin
 * @Date: 2021-01-18 12:54:44
 * @LastEditors: xuhuining
 * @LastEditTime: 2022-08-02 11:15:17
-->
<template>
  <div class='operation_block'>
    <div v-if="curItem" class="content_state">
      <div class="like state" @click="likeClick(curItem)">
        <img
            :src="curItem.orLike?require('../../../assets/images/icon/like3.png'):require('../../../assets/images/icon/like1.png')"
            alt="">
        <span>{{ curItem.like ? fomatterNum(curItem.like) : 0 }}</span>
      </div>
      <div class="collect state" @click="collectClick(curItem)">
        <img
            :src="curItem.orFavorites?require('../../../assets/images/icon/collect3.png'):require('../../../assets/images/icon/collect1.png')"
            alt="">
        <span>{{ curItem.collect ? fomatterNum(curItem.collect) : 0 }}</span>
      </div>
      <div class="share state" @click='shareToast(curItem)'>
        <img alt="" src="../../../assets/images/icon/share2.png">
        <span>{{ curItem.share ? fomatterNum(curItem.share) : 0 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {Debounce, fomatterNum, globalGoLogin} from "@/assets/js/common.js";
import API from '@/utils/axiosApi/calendarApi'

export default {
  props: {
    curItem: {
      type: Object,
      default: null
    },
    ABtest: {
      type: String,
      default: 'A'
    }
  },
  mounted() {
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    fomatterNum,
    // 分享弹窗显示
    shareToast: Debounce(function (item) {
      const that = this;
      this.$toast({
        message: "可长按图片保存分享",
        duration: 2000
      })
      //   that.$emit('weShare', item.id)
      API.addShare({}, {id: item.id}, res => {
        if (res.code == '200') {
          that.curItem.share += 1;
        }
      })
      sensors.track('Share', {
        'content_id': item.id,
        'content_title': '',
        'Column': '育儿日历',
        'Poster_Date': item.startDate,
        // 'A_B_flow': this.ABtest
      })
    }),
    // 点赞和取消点赞
    likeClick: Debounce(function (item) {
      if (!this.UserInfo || this.UserInfo.mobile == '' || this.UserInfo.mobile == null) {
        // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href });
        globalGoLogin()
      } else {
        const orLike = this.curItem.orLike;
        const that = this;
        if (!orLike) {
          API.addLike({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.curItem.like += 1;
              that.curItem.orLike = true;
              that.$toast({
                duration: 2000,
                message: "点赞成功",
                context: that
              });
            }
          })
          sensors.track('Support', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        } else {
          API.cancelLike({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.curItem.like -= 1;
              that.curItem.orLike = false;
            }
          })
          sensors.track('Unsupport', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        }
      }
    }, 100),
    // 收藏和取消收藏
    collectClick(item) {
      if (!this.UserInfo || this.UserInfo.mobile == '' || this.UserInfo.mobile == null) {
        // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href });
        globalGoLogin()
      } else {
        const orFavorites = this.curItem.orFavorites;
        const that = this;
        if (!orFavorites) {
          API.addCollect({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.curItem.collect += 1;
              that.curItem.orFavorites = true;
              that.$toast({
                duration: 2000,
                message: "收藏成功",
                context: that
              });
            }
          })
          sensors.track('Save', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        } else {
          API.cancelCollect({}, {id: item.id, crmId: this.UserInfo.crm_id}, res => {
            if (res.code == '200') {
              that.curItem.collect -= 1;
              that.curItem.orFavorites = false;
            }
          })
          sensors.track('CancelSave', {
            'content_id': item.id,
            'content_title': '',
            'Column': '育儿日历',
            'Poster_Date': item.startDate,
            // 'A_B_flow': this.ABtest
          })
        }
      }
    },
    // 获取育儿日历签到数据
    getSignData(flag, data) {
      this.signToastShow = flag;
      this.signData = data;
    },
  },
}
</script>

<style lang="less" scoped>
.operation_block {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background: #fff;
  z-index: 999;

  .content_state {
    width: 279px;
    overflow: hidden;
    margin: 0 auto;

    .state {
      width: 33.33%;
      text-align: center;
      font-size: 14px;
      color: #999999;
      line-height: 1;
      float: left;
      padding: 19px 0;

      img {
        width: 14px;
        height: 14px;
        margin-right: 3px;
        vertical-align: middle;
      }

      span {
        vertical-align: text-bottom;
      }
    }
  }
}
</style>
